import BecomeTrainerTermsAndConditionsComponent from "../../components/become-trainer/become-trainer-terms-and-conditions";

const BecomeTrainerTermsAndConditionsPage = () => <BecomeTrainerTermsAndConditionsComponent />

export default BecomeTrainerTermsAndConditionsPage;